import Vue from 'vue'
import Vuex from 'vuex'
import {
    productModule,
    // scraperSiteModule,
    // scraperTitleModule,
    // scraperGroupModule,
    // scraperCategoryModule,
    commissionModule,
    conversionModule,
    couponModule,
    dashboardModule,
    filterMeComponentModule,
    linkModule,
    mediaModule,
    transactionModule,
    promotionModule,
    publisherModule,
    storeModule,
    ticketModule,
    toastComponentModule,
    userModule,
    roleModule,
    categoryModule,
    loadingComponentModule,
    messageComponentModule,
    v2CommissionModule,
    widgetModule,
    oauth2Module,
    scraperSiteIdModule,
    notificationModule,
    pageBuilderModule,
    walletModule,
    transactionsModule,
    invoiceModule,
    shortLinkModule,
    agreementModule,
    contactUsModule,
    campaignModule,
    tagModule,
    conversationModule,
} from './modules'
import ability from '@/ability'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        //
    ],
    modules: {
        transactions: transactionsModule,
        wallet: walletModule,
        notification: notificationModule,
        pageBuilder: pageBuilderModule,
        // scraperGroup: scraperGroupModule,
        // scraperTitle: scraperTitleModule,
        // scraperSite: scraperSiteModule,
        // scraperSiteId: scraperSiteIdModule,
        // scraperCategory: scraperCategoryModule,
        product: productModule,
        user: userModule,
        promotion: promotionModule,
        commission: commissionModule,
        publisher: publisherModule,
        conversion: conversionModule,
        dashboard: dashboardModule,
        transaction: transactionModule,
        media: mediaModule,
        toastComponent: toastComponentModule,
        link: linkModule,
        store: storeModule,
        coupon: couponModule,
        filterMeComponent: filterMeComponentModule,
        ticket: ticketModule,
        role: roleModule,
        category: categoryModule,
        loadingComponent: loadingComponentModule,
        messageComponent: messageComponentModule,
        v2commission: v2CommissionModule,
        widget: widgetModule,
        oauth2: oauth2Module,
        invoice: invoiceModule,
        shortLink: shortLinkModule,
        agreement: agreementModule,
        contactUs: contactUsModule,
        campaign: campaignModule,
        tag: tagModule,
        conversation: conversationModule,
    },
    getters: {
        ability() {
            return ability
        }
    }
})